import { render, staticRenderFns } from "./mockExam.vue?vue&type=template&id=0f84856a&scoped=true&"
import script from "./mockExam.vue?vue&type=script&lang=js&"
export * from "./mockExam.vue?vue&type=script&lang=js&"
import style0 from "./mockExam.vue?vue&type=style&index=0&id=0f84856a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84856a",
  null
  
)

export default component.exports